import { gql } from "@apollo/client";
import React from "react";

import VideoPlayerHeader from "./VideoPlayerHeader";

export const PotwVideoPlayerHeaderFragment = gql`
  fragment PotwVideoPlayerHeaderFragment on PotwCompetition {
    name
    org {
      id
      name
    }
  }
`;

// Competition name and org of a Top 5 video.
export default function PotwVideoPlayerHeader({ potwCompetition, action }) {
  if (!potwCompetition) return null;

  return (
    <VideoPlayerHeader
      title={potwCompetition.name}
      subtitle={[potwCompetition.org?.name, "Top 5"].filter(Boolean).join(" · ")}
      action={action}
    />
  );
}
